export const serviceHeroBenefits = [
  "Tempi e costi chiari fin dall'inizio",
  "Prototipo rapido (PoC) prima dello sviluppo",
  "Supporto post-lancio e monitoraggio",
];

export const serviceHeroTags = [
  "IA",
  "Web App",
  "Siti Web",
  "Automazioni",
];

export const serviceVisualNodes = [
  {
    title: "Web App",
    text: "Dashboard, gestionali e strumenti interni.",
  },
  {
    title: "IA",
    text: "Assistenti, analisi dati e automazioni mirate.",
  },
  {
    title: "Siti Web",
    text: "Presenza digitale veloce, chiara e responsive.",
  },
  {
    title: "Supporto",
    text: "Deploy, monitoraggio e miglioramenti continui.",
  },
];

export const serviceProcessSteps = [
  {
    n: "01",
    label: "Allineamento",
    title: "Brief & Obiettivi",
    text: "Capisco bisogni, vincoli e risultati attesi. Definiamo scope, priorita e criteri di successo.",
  },
  {
    n: "02",
    label: "Validazione",
    title: "Prototipo / PoC",
    text: "Creo un mockup o una proof-of-concept veloce per validare l'idea prima di investire nello sviluppo completo.",
  },
  {
    n: "03",
    label: "Costruzione",
    title: "Sviluppo iterativo",
    text: "Lavoro per rilasci brevi, demo frequenti e feedback continui, mantenendo il codice documentato e manutenibile.",
  },
  {
    n: "04",
    label: "Lancio",
    title: "Go-live & Supporto",
    text: "Gestisco deploy, monitoraggio, ottimizzazioni e supporto post-lancio per mantenere stabile la soluzione.",
  },
];

export const serviceRecentProjectIds = [
  "studio-contabile",
  "scout-bari",
  "condomini-saas",
];
